import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

/**
 * Detect when the list header is stuck to the top of the list
 * Source: https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
 */
export function useIsStuck(ref: React.RefObject<HTMLDivElement>) {
  const [isStuck, setIsStuck] = useState(false);

  const debouncedSetIsStuck = useMemo(
    () => debounce(setIsStuck, 100, { leading: true }),
    [setIsStuck]
  );

  useEffect(() => {
    let observer: IntersectionObserver;
    if (ref.current) {
      observer = new IntersectionObserver(
        ([event]) => {
          debouncedSetIsStuck(event.intersectionRatio < 1);
        },
        { threshold: [1] }
      );

      observer.observe(ref.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [debouncedSetIsStuck, ref]);

  return isStuck;
}
